import { Color } from "../../defines/colors"
import { ItemType } from "../../defines/enums"
import { Symbol } from "../../defines/symbols"
import { Position } from "../../defines/types"
import { Item } from "./item"

export class Binder extends Item {
  constructor(position: Position) {
    const render = {
      symbol: [Symbol.BINDER],
      light: Color.BINDER,
      dark: Color.BINDER,
    }
    const levelRequired = 1
    super(ItemType.BINDER, levelRequired, position, render, "pigment binder")
  }
}
